export const setSessionItem = (key: string, data: string) => {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }
};

export const getSessionItem = (key: string) => {
    if (typeof Storage !== 'undefined') {
        let value = window.sessionStorage.getItem(key) as any;
        try {
            value = JSON.parse(value);
        } catch (error) {}
        return value;
    }
};

export const removeSessionItem = (key: string) => {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.removeItem(key);
    }
};
